import MstbetHorseTicketFooter from "./MstbetHorseTicketFooter";
import MstbetHorseTicketHeader from "./MstbetHorseTicketHeader";
import MstbetHorseTicketSelections from "./MstbetHorseTicketSelections";


function MstbetHorseTicket(props) {
    const ticketData = props.ticketData;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; // TODO: add "isEstero" in configuration
	const isCashout = props.isCashout;
	const terminalCopy = props.terminalCopy;
	const printAgainTerminalRec = props.printAgainTerminalRec;
	const user = props.user;
	const conf = props.conf;
	const skinProperties = props.skinProperties;

    return <>
	<div id={"ticket-" + ticketData.idTicket} className="ticket-container">
		<MstbetHorseTicketHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} conf={conf} user={user} skinProperties={skinProperties} printAgainTerminalRec={printAgainTerminalRec} terminalCopy={terminalCopy} isCashout={isCashout} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		<MstbetHorseTicketSelections conf={conf} user={user} skinProperties={skinProperties} printAgainTerminalRec={printAgainTerminalRec} terminalCopy={terminalCopy} isCashout={isCashout} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		<MstbetHorseTicketFooter  conf={conf} user={user} skinProperties={skinProperties} printAgainTerminalRec={printAgainTerminalRec} terminalCopy={terminalCopy} isCashout={isCashout} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />	
		{/*  MSTBET */}
	</div>
	</>
}

export default MstbetHorseTicket;